import { useEffect, useRef, useState } from "react";
import toastContext from "./ToastContext";
import Success from "../../components/Toast_v2/Icons/Success";
import Error from "../../components/Toast_v2/Icons/Error";
import Info from "../../components/Toast_v2/Icons/Info";
import { TOAST_TYPE } from "../../constants/Constants";
import Suspect from "../../components/Toast_v2/Icons/Suspect";
const ToastState = (props) => {
  const [list, setList] = useState([]);
  const [progressList, setProgressList] = useState([]);
  const [batchAssignClick,setBatchAssignClick] = useState(false);
  const progressIdCounter = useRef(0);
  let toastProperties = null;

  const showProgressToast = (title, progress) => {
    progressIdCounter.current += 1;
    const id = progressIdCounter.current;
    toastProperties = {
      id,
      title: title,
      progress: progress,
      color: "#3684F3",
      show: true
    };
    setProgressList((prevList) => [...prevList, toastProperties]);
    return id;
  };

  const updateProgress = (studyZipProgressId, studyZipProgress) => {
    setProgressList((prevList) =>
      prevList.map((p) =>
        p.id === studyZipProgressId ? { ...p, progress: studyZipProgress } : p
      )
    );
  }

  const hideProgress = (studyZipProgressId) => {
    setProgressList((prevList) =>
      prevList.map((p) =>
        p.id === studyZipProgressId ? { ...p, show: false } : p
      )
    );
  }

  const showToastv2 = (type, title, action) => {
    switch (type) {
      case TOAST_TYPE.SUCCESS:
        toastProperties = {
          id: list.length + 1,
          title: title,
          color: "#32A75A",
          icon: <Success />,
          toastType : type
        };
        break;
      case TOAST_TYPE.ERROR:
        toastProperties = {
          id: list.length + 1,
          title: title,
          color: "#EF4C49",
          icon: <Error />,
          toastType : type
        };
        break;
      case TOAST_TYPE.INFO:
        toastProperties = {
          id: list.length + 1,
          title: title,
          color: "#3684F3",
          icon: <Info />,
          toastType : type
        };
        break;
      case TOAST_TYPE.BATCHASSIGN:
        toastProperties = {
          id: list.length + 1,
          title: title,
          color: "#3684F3",
          icon: <Info />,
          toastType : type,
          action:action
        };
        break;
        case TOAST_TYPE.SUSPECT:
          toastProperties = {
            id: list.length + 1,
            title: title,
            color: "#FFA500",
            icon: <Suspect />,
            toastType : type,
          };
        break;
      default:
        toastProperties = [];
    }
    setList((prev) => {
      return [...prev, toastProperties]
    });
    return toastProperties.id;
  };

  const updateToastv2 = (toastId, type, title, action) => {
    const updatedProgressIndex = list.findIndex(
      (p) => p.id === toastId
    );
    const updatedProgress = list[updatedProgressIndex];
    updatedProgress.title = title;
    const newProgressList = [...list];
    newProgressList[updatedProgressIndex] = updatedProgress;
    setList(newProgressList);

  }

  return (
    <toastContext.Provider
      value={{
        list,
        setList,
        showToastv2,
        updateToastv2,
        showProgressToast,
        progressList,
        setProgressList,
        updateProgress,
        hideProgress,
        setBatchAssignClick,
        batchAssignClick
      }}
    >
      {props.children}
    </toastContext.Provider>
  );
};

export default ToastState;
